const plugin = {
  settings: {
    value: 3,
    initial: 3
  },

  update: function() {
    var offset = 0;
    var scroll = Math.max(
      1 + Math.max(0, offset + document.querySelector(".preview").scrollTop),
      1 + posTop()
    );

    var scroll = translate(scroll, 0, 400, 0, 100) / 10;

    this.settings.value = Math.min(
      Math.max(this.settings.initial, scroll * scroll),
      100
    );
    this.render(this.settings.value);
  },

  render: function(value) {
    var value = value ? value : this.settings.value;

    var canvas = document.getElementById("canvas");
    var ctx = canvas.getContext("2d");

    var element = document.querySelector("img");
    var rect = element.getBoundingClientRect();

    canvas.width = rect.width;
    canvas.height = rect.height;

    canvas.style.position = "absolute";
    canvas.style.top = element.offsetTop + "px";
    canvas.style.left = element.offsetLeft + "px";
    canvas.style.pointerEvents = "none";

    pixelate(canvas, value);
  },

  mount: function() {
    // post render
    var element = document.querySelector("img");
    var newElement = document.querySelector("canvas");

    element.addEventListener("load", () => {
      element.parentNode.insertBefore(newElement, element);
      element.parentNode.style.position = "relative";
      this.render();
    });

    // element.setAttribute("src", element.src)

    if (element.complete && element.naturalHeight !== 0) {
      element.parentNode.insertBefore(newElement, element);
      element.parentNode.style.position = "relative";
      setTimeout(() => {
        this.render();
      });
    }
  }
};

// MAIN function
function pixelate(canvas, v) {
  console.log(v);
  var canvas = document.getElementById("canvas");
  var ctx = canvas.getContext("2d");
  let smoothing = v == 100 ? true : false;
  ctx.mozImageSmoothingEnabled = smoothing;
  ctx.webkitImageSmoothingEnabled = smoothing;
  ctx.imageSmoothingEnabled = smoothing;

  var img = document.querySelector("img");

  // if in play mode use that value, else use slider value
  var size = v * 0.01,
    // cache scaled width and height
    w = Math.round(canvas.width * size),
    h = Math.round(canvas.height * size);

  // draw original image to the scaled size
  ctx.drawImage(img, 0, 0, w, h);

  // then draw that scaled image thumb back to fill canvas
  // As smoothing is off the result will be pixelated
  ctx.drawImage(canvas, 0, 0, w, h, 0, 0, canvas.width, canvas.height);
}

function translate(value, low1, high1, low2, high2) {
  return low2 + (high2 - low2) * ((value - low1) / (high1 - low1));
}

export default plugin;

function posTop() {
  return typeof window.pageYOffset != "undefined"
    ? window.pageYOffset
    : document.documentElement.scrollTop
    ? document.documentElement.scrollTop
    : document.body.scrollTop
    ? document.body.scrollTop
    : 0;
}
